import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { environment } from '../../environments/environment';
import { IFundingAccountsResponse } from '../interfaces/funding-accounts-response';
import { IDeleteFundingAccountResponse } from '../interfaces/delete-funding-account-response';
import { PaymentType } from '../enums/payment-type';

@Injectable({
  providedIn: 'root'
})
export class FundingAccountsService {

  private fundingAccountsUrl = '/client/funding-accounts';

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public fetchFundingAccounts(envRegion: string, sessionId: string): Observable<IFundingAccountsResponse> {
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.fundingAccountsUrl;
    // url = url.replace('{bid}', billerId).replace('{acct}', billingAccountNumber);
    return this.http.get<IFundingAccountsResponse>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  // public getFundigAccounts(envRegion: string, sessionId: string) {
  //   if (sessionId && envRegion) {
  //     // let envRegion: string = 'qa';
  //     // let billerId: string = '555348';
  //     // let billingAccountNumber: string = '99901';
  //     this.fetchFundingAccounts(envRegion, sessionId)
  //     .subscribe(
  //       (response) => {
  //         let fundingAccountResponse = response;
  //         if (fundingAccountResponse) {
  //           this.fundingAccounts = fundingAccountResponse.tokenList;
  //           this.fundingAccounts.sort((a, b) => (a.tokenid > b.tokenid) ? 1 : -1);
  //           this.fundingAccounts.slice(0, 3);
  //           // Add a column for the checkbox
  //           this.fundingAccounts.map((obj) => {
  //             obj.checked = false;
  //             return obj;
  //           })
  //           // Figure out the message for the customer depending on whether there is already at least one funding account
  //           if (this.fundingAccounts) {
  //             if (this.fundingAccounts.length > 0) {
  //               this.dsbMessage = this.sharedService.getCustomizedPrompt("FUNDING_ACCOUNTS_EXIST");
  //             }
  //           }
  //         }
  //       }
  //     )
  //   }
  // }


  public linkFundingAccountToOccurrence(envRegion: string, sessionId: string,
        fundingAccountToken: string, disbursementOccurrenceUuid: string): Observable<boolean> {
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.fundingAccountsUrl;
    let request = {
      "fundingAccountToken": fundingAccountToken,
      "disbursementOccurrenceUuid": disbursementOccurrenceUuid
    };
    return this.http.post<boolean>(url, request, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public deleteFundingAccount(envRegion: string, sessionId: string,
    fundingAccountToken: string): Observable<IDeleteFundingAccountResponse> {
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.fundingAccountsUrl + "/" + fundingAccountToken;
    return this.http.delete<IDeleteFundingAccountResponse>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

}
